import DeviceFirmwarePage from "./DeviceFirmwarePage";
import { DataGridSettingsProvider } from "@/components/DataGridSettingsProvider";
import { ModalProvider } from "@/components/ModalProvider";
import { PresetProvider } from "@/components/PresetProvider";

export function DeviceFirmwarePageWrapper() {
  return (
    <PresetProvider scope="deviceFirmware.preset">
      <DataGridSettingsProvider pageType="deviceFirmware">
        <ModalProvider>
          <DeviceFirmwarePage />
        </ModalProvider>
      </DataGridSettingsProvider>
    </PresetProvider>
  );
}
